// frontend/src/components/DifficultyBadge.tsx
import React from "react";
import { Badge } from "./Badge";

interface DifficultyBadgeProps {
  difficulty: "Easy" | "Medium" | "Hard";
  className?: string;
}

export const DifficultyBadge: React.FC<DifficultyBadgeProps> = ({
  difficulty,
  className,
}) => {
  const getVariant = (diff: string) => {
    switch (diff) {
      case "Easy":
        return "success" as const;
      case "Medium":
        return "warning" as const;
      case "Hard":
        return "danger" as const;
      default:
        return "secondary" as const;
    }
  };

  return (
    <Badge variant={getVariant(difficulty)} size="small" className={className}>
      {difficulty}
    </Badge>
  );
};
